<template>
	<FloatingRoundedMenu max-width="239" nudge-left="265" v-model="localValue">
		<template v-slot:activator="{ on }">
			<slot name="activator" v-bind="{ on }" />
		</template>
		<div @mouseover="onMouseOver" @mouseleave="onMouseLeave">
			<FormulaSelectorContainer
				:formulas="formulas"
				:allowKeyboardNavigation="allowKeyboardNavigation"
				:autoFocus="autoFocus"
				v-on="$listeners"
			/>
		</div>
	</FloatingRoundedMenu>
</template>

<script>
import FloatingRoundedMenu from './FloatingRoundedMenu';
import FormulaSelectorContainer from './FormulaSelectorContainer';

export default {
	name: 'FormulaSelectorMenu',
	props: {
		formulas: { type: Array },
		allowKeyboardNavigation: { type: Boolean },
		autoFocus: { type: Boolean },
		showFormula: { type: Boolean },
	},
	components: { FloatingRoundedMenu, FormulaSelectorContainer },
	methods: {
		onMouseOver() {
			this.isHovered = true;
		},
		onMouseLeave() {
			this.isHovered = false;
			this.localValue = false;
		},
	},
	data() {
		return {
			localValue: this.showFormula,
			isHovered: false,
		};
	},
	watch: {
		localValue: {
			handler(newV) {
				this.$emit('show-formula-update', newV);
			},
		},
		showFormula: {
			handler(newV) {
				if (!this.isHovered) {
					this.localValue = newV;
				}
			},
			immediate: true,
		},
	},
};
</script>

<style lang="scss" scoped></style>
